import { SearchForm } from './SearchForm';
import { SearchResult } from './SearchResult';
import { MoveToJianListButton } from '../../components/MoveToJianListButton';

export const JianSearch = () => {
  return (
    <div className="max-h-[calc(100vh-8rem)] w-full flex gap-8 px-10 max-xl:flex-col">
      <MoveToJianListButton />
      <SearchForm />
      <div className="flex flex-col flex-1 overflow-x-hidden">
        <h2 className="text-darkblue_100 font-bold text-2xl mb-4">検索結果</h2>
        <SearchResult />
      </div>
    </div>
  );
};
